/*
* @providesModule SelectPaypalEmailStyle
* 
*/

import SkillzStyle from 'SkillzStyle';
import Sizes from 'Sizes';
import SKZConstants from 'SKZConstants';

import {StyleSheet} from 'react-native';

const {
  fontSizeH1,
  fontSizeH4,
  fontSizeH5,
  fontRegular,
  fontSecondary,
  fontMedium,
  viewCornerRadiusSecondary,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({

  landscapeAndTabletBG: {
    flex: 1,
  },

  container: {
    flex: 1,
    backgroundColor: '#FFF',
  },

  landscapePhoneContainer: {
    flex: 1,
    width: 374,
    marginTop: 22,
    backgroundColor: '#FFF',
    borderTopLeftRadius: viewCornerRadiusSecondary.borderRadius,
    borderTopRightRadius: viewCornerRadiusSecondary.borderRadius,
    alignSelf: 'center',
    overflow: 'hidden',
  },

  tabletContainer: {
    flex: 1,
    width: SKZConstants.TABLET_USABLE_AREA_WIDTH_PERCENT,
    marginVertical: 150,
    alignSelf: 'center',
    borderRadius: viewCornerRadiusSecondary.borderRadius,
    backgroundColor: '#FFF',
    overflow: 'hidden',
  },

  selectedPrimaryEmail: {
    height: 96,
  },

  addEmailContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    height: Sizes.select({
      tablet: 76,
      other: 56,
    }),
    paddingHorizontal: Sizes.select({
      tablet: 50,
      other: 24,
    }),
  },

  plusSign: {
    ...fontRegular,
    ...fontSizeH1,
    marginBottom: 4,
    marginRight: 8,
    color: 'rgb(74, 144, 226)',
  },

  blueText: {
    ...fontMedium,
    ...fontSizeH4,
    color: 'rgb(74, 144, 226)',
  },

  footer: {
    height: 64,
    backgroundColor: '#FFF',
    justifyContent: 'center',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: 'rgb(219, 219, 219)',
  },

  saveButton: {
    alignSelf: 'center',
    width: 174,
    height: 34,
  },

  saveButtonText: {
    ...fontSizeH4,
    ...fontSecondary,
    color: '#FFF',
  },

  divider: {
    backgroundColor: 'rgba(172, 172, 172, 0.2)',
    height: 1,
    marginHorizontal: Sizes.select({
      tablet: 40,
      other: 14,
    }),
  },

  addEmailInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    height: Sizes.select({
      tablet: 100,
      other: 83,
    }),
    paddingHorizontal: Sizes.select({
      tablet: 50,
      other: 24,
    }),
  },

  addEmailInputWrapper: {
    flex: 1,
    paddingBottom: 10,
  },

  addEmailInput: {
    ...fontRegular,
    ...fontSizeH4,
    color: 'rgb(51, 51, 51)',
  },

  addEmailLabel: {
    ...fontRegular,
    ...fontSizeH5,
    color: 'rgb(172, 172, 172)',
  },

  addEmailInputButton: {
    width: 72,
    height: 28,
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    borderWidth: 1,
    borderColor: 'rgb(74, 144, 226)',
    marginLeft: 24,
  },

  addEmailInputButtonText: {
    ...fontSizeH4,
    ...fontSecondary,
    color: 'rgb(74, 144, 226)',
  },

});
